import { Destination, FormField } from "@prequel/react";

import ConstWrapper from "./ConstWrapper";
import InputWrapper from "./InputWrapper";
import InternalWrapper from "./InternalWrapper";
import RadioWrapper from "./RadioWrapper";
import SelectWrapper from "./SelectWrapper";
import TextAreaWrapper from "./TextAreaWrapper";

import { MagicLink } from "@/types";
import { Source } from "@/types/sources";
import { SourceFormField } from "@/types/sources/form";

export type WrapperProps<F extends FormField | SourceFormField, C extends Destination | Source | MagicLink> = {
  field: F;
  connection: C;
  setConnectionField: (key: keyof C, value: string | boolean | string[] | number) => void;
  isEditing: boolean;
  disabled?: boolean;
};
const WrapperSelector = <F extends FormField | SourceFormField, C extends Destination | Source | MagicLink>({
  field,
  connection,
  setConnectionField,
  disabled = false,
  isEditing,
}: WrapperProps<F, C>) => {
  if (field.const) {
    return (
      <ConstWrapper
        field={field}
        connection={connection}
        setConnectionField={setConnectionField}
        isEditing={isEditing}
      />
    );
  } else if (field.internal) {
    return (
      <InternalWrapper
        field={field}
        connection={connection}
        setConnectionField={setConnectionField}
        disabled={disabled}
        isEditing={isEditing}
      />
    );
  } else if (field.form_element === "select") {
    return (
      <SelectWrapper
        field={field as F & { form_element: "select" }}
        connection={connection}
        setConnectionField={setConnectionField}
        disabled={disabled}
        isEditing={isEditing}
      />
    );
  } else if (field.form_element === "input") {
    return (
      <InputWrapper
        field={field as F & { form_element: "input" }}
        connection={connection}
        setConnectionField={setConnectionField}
        disabled={disabled}
        isEditing={isEditing}
      />
    );
  } else if (field.form_element === "textarea") {
    return (
      <TextAreaWrapper
        field={field as F & { form_element: "textarea" }}
        connection={connection}
        setConnectionField={setConnectionField}
        disabled={disabled}
        isEditing={isEditing}
      />
    );
  } else if (field.form_element === "radio") {
    return (
      <RadioWrapper
        field={field as F & { form_element: "radio" }}
        connection={connection}
        setConnectionField={setConnectionField}
        disabled={disabled}
        isEditing={isEditing}
      />
    );
  } else {
    return null;
  }
};

export default WrapperSelector;
